import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { NFLookupContract } from "../../../../Shared/NewForms/NFLookupContract";
import { NFLookupEmployee } from "../../../../Shared/NewForms/NFLookupEmployee";
import { useFormContext } from "react-hook-form";

const ExpenseCashsLoanToEmployeeDetail = () => {
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation();
  const { watch } = useFormContext();

  const handleListChange = (selectedOption: number) => {
    if (selectedOption === 0) {
      setShowModal(true);
    } else if (selectedOption === 1) {
      setShowModal(false);
    }
  };
  return (
    <Row>
      <Col sm={6}>
        <NFLookupEmployee title={t("Employee")} fieldName={"employeeId"} required />
      </Col>
      <Col sm={6}>
        <NFLookupContract fieldName="contractId" title={t("Contract")} />
      </Col>
      {/*     
      {showModal && (
        <NFormTable fieldArray={"payments"}>
          <NFLookupCurrency title={t("Currency")} fieldName="currencyId" width={500} />
          <NFIntInput title={t("Amount")} fieldName="amount" />
          <NFIntInput title={t("CurrencyAmount")} fieldName="currencyAmount" />
        </NFormTable>
      )} */}
    </Row>
  );
};

export default ExpenseCashsLoanToEmployeeDetail;
